/**
 * @flow
 */
'use strict';

export const complaintDurationCodes = [
{"code":"1 hour"},
{"code":"2 hours"},
{"code":"3 hours"},
{"code":"5 hours"},
{"code":"1 day"},
{"code":"2 days"},
{"code":"3 days"},
{"code":"1 week"},
{"code":"2 weeks"},
{"code":"1 month"},
{"code":"2 month"},
{"code":"1 year"},
]
